import { render } from "./BlogCard.vue?vue&type=template&id=364f2581&scoped=true"
import script from "./BlogCard.vue?vue&type=script&lang=js"
export * from "./BlogCard.vue?vue&type=script&lang=js"

import "./BlogCard.vue?vue&type=style&index=0&id=364f2581&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364f2581"]])

export default __exports__